import { render, staticRenderFns } from "./BoxInput.vue?vue&type=template&id=9c1bfb64&scoped=true&"
import script from "./BoxInput.vue?vue&type=script&lang=js&"
export * from "./BoxInput.vue?vue&type=script&lang=js&"
import style0 from "./BoxInput.vue?vue&type=style&index=0&id=9c1bfb64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1bfb64",
  null
  
)

export default component.exports